/**
 * Created by mark on 11/12/2017.
 */



import React from 'react';
import { Row } from 'react-bootstrap'
import { loadStripe } from "@stripe/stripe-js";

export default class Authentication extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    async componentDidMount() {
      const stripePromise = loadStripe('pk_live_pTdLrLzpfvyOg1ZAKbq4XHEa');
      //const stripePromise = loadStripe('pk_test_14ng1mayzzrl7tCJJrxwxyym');

      const stripe = await stripePromise;

        var checkoutButton = document.getElementById('checkout-button-sku_Gvulli8T8jBHXP');
        checkoutButton.addEventListener('click', function () {
            // When the customer clicks on the button, redirect
            // them to Checkout.
            stripe.redirectToCheckout({
                items: [{ sku: 'sku_Gvvmzcb91Cz8ko', quantity: 1 }],

                // Do not rely on the redirect to the successUrl for fulfilling
                // purchases, customers may not always reach the success_url after
                // a successful payment.
                // Instead use one of the strategies described in
                // https://stripe.com/docs/payments/checkout/fulfillment
                successUrl: 'https://www.languagenut.com/home/#/success',
                cancelUrl: 'https://www.languagenut.com/home/#/eu',
            })
                .then(function (result) {
                    if (result.error) {
                        // If `redirectToCheckout` fails due to a browser or network
                        // error, display the localized error message to your customer.
                        var displayError = document.getElementById('error-message');
                        displayError.textContent = result.error.message;
                    }
                });
        });

        var secondaryButton = document.getElementById('checkout-button-sku_GvtZwMbPccDP3T');
        secondaryButton.addEventListener('click', function () {
            // When the customer clicks on the button, redirect
            // them to Checkout.
            stripe.redirectToCheckout({
                items: [{ sku: 'sku_GvvoytmAoDeO6E', quantity: 1 }],

                // Do not rely on the redirect to the successUrl for fulfilling
                // purchases, customers may not always reach the success_url after
                // a successful payment.
                // Instead use one of the strategies described in
                // https://stripe.com/docs/payments/checkout/fulfillment
                successUrl: 'https://www.languagenut.com/home/#/success',
                cancelUrl: 'https://www.languagenut.com/home/#/eu',
            })
                .then(function (result) {
                    if (result.error) {
                        // If `redirectToCheckout` fails due to a browser or network
                        // error, display the localized error message to your customer.
                        var displayError = document.getElementById('error-message');
                        displayError.textContent = result.error.message;
                    }
                });
        });

    }

    render() {

        return <div>
            <Row>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <center><img height="100px" src="https://s3-eu-west-1.amazonaws.com/marketing.languagenut.com/Sales%20site/Languagenut%20Sales%20Sites%20Image%20Assets/LN%20Logo.png" /></center>
                </div>
            </Row>
            <br />
            <Row>
            <div class="col-lg-1"></div>
            <div class="row d-flex justify-content-center"  style={{display:"flex", flexWrap:"wrap"}}>
            <div class="card col-lg-5" style={{marginRight:"50px"}}>
            <div class="card-body" style={{display:"flex", justifyContent:"space-between", flexDirection:"column"}}>
                <center><img height="150px" src="./img/primary_eu.png" /></center>
                  <hr />
                  <ul class="fa-ul">
                      <li><span class="fa-li"><i class="fas fa-check"></i></span>Licence for a Single User</li>
                      <li><span class="fa-li"><i class="fas fa-check"></i></span>Access to 22 world languages, including French and Spanish </li>
                      <li><span class="fa-li"><i class="fas fa-check"></i></span>Extensive vocabulary bank with 1500 beginner vocabulary words and phrases</li>
                      <li><span class="fa-li"><i class="fas fa-check"></i></span>14 engaging & fun games in all four key skills​– Listening, Speaking, Reading and Writing</li>
                      <li><span class="fa-li"><i class="fas fa-check"></i></span>Interactive verb conjugation games in 20+ verbs in 4+ tenses</li>
                      <li><span class="fa-li"><i class="fas fa-check"></i></span>Sentence building exercises comprising over 400 sentences</li>
                      <li><span class="fa-li"><i class="fas fa-check"></i></span>Practise forming full sentences and sentence chunks</li>
                      <li><span class="fa-li"><i class="fas fa-check"></i></span>Improve your pronunciation with our engaging phonics activities</li>
                  </ul>
                  <p>Individual licences can be used on laptops, desktops and tablets. They're not available on mobile phones, as the mobile version is designed around teacher-set assignments.</p>
                  <div style={{display:"flex", alignItems:"center"}}>
                  <a id="checkout-button-sku_Gvulli8T8jBHXP"
                      role="link" class="btn btn-block btn-primary text-uppercase" style={{display:"flex", justifyContent:"center", width:"90%", margin:"auto"}}>Buy Now</a>
              </div>
              </div>
              </div>
              <div class="card col-lg-5">
              <div class="card-body" style={{display:"flex", justifyContent:"space-between", flexDirection:"column"}}>
                            <center><img height="150px" src="./img/secondary_eu.png" /></center>
                            <hr />
                            <ul class="fa-ul">
                                <li><span class="fa-li"><i class="fas fa-check"></i></span>Licence for a Single User</li>
                                <li><span class="fa-li"><i class="fas fa-check"></i></span>French, Spanish and German</li>
                                <li><span class="fa-li"><i class="fas fa-check"></i></span>8000 Exam Revision Questions - GCSE, IGCSE, IB +++</li>
                                <li><span class="fa-li"><i class="fas fa-check"></i></span>Extensive vocabulary bank with 2000+ intermediate and advanced words and phrases</li>
                                <li><span class="fa-li"><i class="fas fa-check"></i></span>30 engaging games in all four key skills</li>
                                <li><span class="fa-li"><i class="fas fa-check"></i></span>Interactive verb conjugation games in 20+ verbs in 4+ tenses</li>
                                <li><span class="fa-li"><i class="fas fa-check"></i></span>Sentence building exercises comprising over 400 sentences</li>
                                <li><span class="fa-li"><i class="fas fa-check"></i></span>Practise forming full sentences and sentence chunks</li>
                                <li><span class="fa-li"><i class="fas fa-check"></i></span>Improve your pronunciation with our engaging phonics activities</li>
                            </ul>
                            <p>Individual licences can be used on laptops, desktops and tablets. They're not available on mobile phones, as the mobile version is designed around teacher-set assignments.</p>
                            <div style={{display:"flex", alignItems:"center"}}>
                            <a href="#" id="checkout-button-sku_GvtZwMbPccDP3T"
                                role="link" class="btn btn-block btn-primary text-uppercase" style={{display:"flex", justifyContent:"center", width:"90%", margin:"auto"}}>Buy Now</a>
                            </div>
                </div>
                </div>
                </div>
                <div id="error-message"></div>
            </Row>
        </div>
    }

}